import React from 'react';
import { SBigPlayButton } from './styled';

interface IProps {
  accentColor: string;
  onClick: () => void;
}

const BigPlayButton: React.FC<IProps> = ({ accentColor, onClick }) => (
  <SBigPlayButton $accentColor={accentColor} onClick={onClick} aria-label="Play video">
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 5v14l11-7z" />
    </svg>
  </SBigPlayButton>
);

export default BigPlayButton;
